import { StaticBaseDao } from '@/dao';
import { IntArray, BiathlonPicture, MatrixShootingCellWarningsAcknowledgement, PostResponse } from '@/objects/generated';

export class MatrixDao extends StaticBaseDao {
    public static async GetBiathlonPictures(eventID: number, biathlonPictureIds?: IntArray): Promise<BiathlonPicture[]> {
        return this.BaseFetchArray(
            BiathlonPicture,
            `Matrix/GetBiathlonPictures` + '?' + (eventID == undefined ? '' : `eventID=${eventID}`),
            'POST',
            biathlonPictureIds,
        );
    }
    public static async GetMatrixShootingCellWarningsAcknowledgementsForEvent(
        eventID: number,
        acknowledgementIds?: IntArray,
    ): Promise<MatrixShootingCellWarningsAcknowledgement[]> {
        return this.BaseFetchArray(
            MatrixShootingCellWarningsAcknowledgement,
            `Matrix/GetMatrixShootingCellWarningsAcknowledgementsForEvent` +
                '?' +
                (eventID == undefined ? '' : `eventID=${eventID}`) +
                '&' +
                (acknowledgementIds == undefined ? '' : `acknowledgementIds=${acknowledgementIds}`),
            'POST',
        );
    }
    public static async SaveMatrixShootingCellWarningsAcknowledgements(
        eventID: number,
        acknowledgements: MatrixShootingCellWarningsAcknowledgement[],
    ): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `Matrix/SaveMatrixShootingCellWarningsAcknowledgements` + '?' + (eventID == undefined ? '' : `eventID=${eventID}`),
            'POST',
            acknowledgements,
        );
    }
}
